import { useEffect, useState } from 'react';
import Modal from '../../../components/Modal/Modal';
import BoostModal from '../../../components/BoostModal/BoostModal';
import { useModalStore } from '../../../store/ModalStore';
import { AdService } from '../../../AdService/AdService';
import { useBoostTaskStore } from '../../../store/BoostStore';
import styles from './DailyTasks.module.css';
import TaskItem from '../../../components/TaskItem/TaskItem';
import {
  claimTask,
  getTasks,
  recordTaskProgress,
} from '../../../Requests/tasks/tasks';
import type { DailyTask } from '../../../types/Tasks/tasks';
import Loader from '../../../components/Loader/Loader';
import cpcIcon from '../../../assets/tasksIcons/cpcIconNew.png';
import cpmIcon from '../../../assets/tasksIcons/cpmIconNew.png';
import { useNotificationStore } from '../../../store/NotificationStore';
import { useBalanceStore } from '../../../store/BalanceStore';

interface DailyTasksProps {
  onLoadingChange?: (isLoading: boolean) => void;
}

const DailyTasks = ({ onLoadingChange }: DailyTasksProps) => {
  const [dailyTasks, setDailyTasks] = useState<DailyTask[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [cpmProgress, setCpmProgress] = useState(0);
  const [cpcProgress, setCpcProgress] = useState(0);
  const setNotification = useNotificationStore(
    (state) => state.setNotification,
  );
  const setBalance = useBalanceStore.getState().setBalance;
  const balance = useBalanceStore.getState().balance;
  useEffect(() => {
    console.log('DailyTasks: Начинаем загрузку');
    setIsLoading(true);
    onLoadingChange?.(true);

    const fetchTasks = async () => {
      try {
        const tasks = await getTasks('our');
        console.log('DailyTasks: Задачи загружены:', tasks);
        setDailyTasks(tasks);
        setCpmProgress(
          tasks.find((task: DailyTask) => task.details.type === 'CPM')
            ?.user_metadata.progress || 0,
        );
        setCpcProgress(
          tasks.find((task: DailyTask) => task.details.type === 'CPC')
            ?.user_metadata.progress || 0,
        );
        setIsLoading(false);
        onLoadingChange?.(false);
        console.log('DailyTasks: Загрузка завершена');
      } catch (error) {
        console.error('DailyTasks: Ошибка загрузки:', error);
        setIsLoading(false);
        onLoadingChange?.(false);
      }
    };
    fetchTasks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Убираем зависимость от onLoadingChange чтобы избежать бесконечных перерендеров
  const { open } = useModalStore();
  const handleCpc = async () => {
    try {
      const availableTasks = await AdService.getAllAvailableTasksNoCpm();
      console.log('Доступные задачи:', availableTasks);
      console.log('Количество задач:', availableTasks.length);
      if (availableTasks.length > 0) {
        for (const task of availableTasks) {
          const showGenericModal =
            task.provider === 'Barza' ||
            task.provider === 'TappAds' ||
            task.provider === 'DreamCoin' ||
            task.provider === 'Barzha' ||
            task.provider === 'Flyer';
          if (showGenericModal) {
            console.log('Открываем модальное окно для рекламы');
            console.log('Task для модалки:', task);
            useBoostTaskStore.getState().setCurrentTask(task);
            useModalStore.getState().setOpen('boost');
            console.log('Модалка должна открыться');
            break;
          } else {
            console.log('Прямой показ рекламы');
            const result = await task.onClick();
            console.log('Результат показа рекламы:', result);
            if (result === 'success') {
              const res = await recordTaskProgress('our', 1, task.provider);
              console.log('Результат записи CPC прогресса:', res);
              setCpcProgress(res.user_metadata.progress);
              if (task.provider === 'Tads') {
                console.log(
                  'Пользователь кликнул на рекламу, вернулся success',
                );
              }
              if (task.provider === 'RichAds') {
                console.log('richasd');
              }
              if (task.provider === 'AdsgramCPC') {
                console.log('adsgramcpc');
              }

              break;
            } else if (result === 'user_cancelled') {
              break;
            } else if (
              result === 'ads_not_found' &&
              task.provider === 'RichAds'
            ) {
              setNotification({
                type: 'Error',
                message: 'Реклама не найдена!',
              });
              break;
            }
          }
        }
      } else {
        setNotification({
          type: 'Error',
          message: 'Нет доступных заданий',
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleCpm = async () => {
    let adShown = false;
    try {
      const availableTasks = await AdService.getAllAvailableTasksNoCpc();
      console.log('availableTasksERE', availableTasks);
      if (availableTasks.length > 0) {
        for (const task of availableTasks) {
          if (adShown) {
            break;
          }
          const result: 'success' | 'user_cancelled' | 'ads_not_found' =
            await task.onClick();
          if (result === 'success') {
            try {
              const res = await recordTaskProgress('our', 2, task.provider);
              console.log('Результат записи прогресса:', res);
              setCpmProgress(res.user_metadata.progress);
              console.log('Реклама показана, вернулся success');
              adShown = true;
            } catch (error) {
              console.error('Ошибка!', error);
            }
            break;
          } else if (result === 'user_cancelled') {
            break;
          } else if (result === 'ads_not_found') {
            console.log(
              `Реклама не найдена у ${task.provider}, пробуем следующий провайдер`,
            );
            if (availableTasks.length === 1) {
              setNotification({
                type: 'Error',
                message: 'Реклама не найдена!',
              });
              break;
            }
            // ads_not_found: продолжаем к следующему провайдеру
            continue;
          }
        }
      } else {
        setNotification({
          type: 'Error',
          message: 'Нет доступных задач для просмотра рекламы',
        });
      }
    } catch (error) {
      console.error('Ошибка в handleCpm:', error);
      setNotification({
        type: 'Error',
        message: 'Ошибка при просмотре рекламы',
      });
    }
  };

  const claimCpcTask = async () => {
    const res = await claimTask('our', 1);
    console.log('Результат клейма CPC', res);
    setBalance(res.wallet.beastcoins);
    setNotification({
      type: 'Success',
      message: 'Награда за задание получена!',
      rewards:
        res.wallet.beastcoins > 0
          ? [{ amount: res.wallet.beastcoins - balance }]
          : undefined,
    });
    if (res && res.countdown_end_date) {
      // Обновляем состояние задачи с кулдауном
      setDailyTasks((prevTasks) =>
        prevTasks.map((task) =>
          task.details.type === 'CPC'
            ? {
                ...task,
                user_metadata: {
                  ...task.user_metadata,
                  status: 'CLAIMED',
                  countdown_end_date: res.countdown_end_date,
                },
              }
            : task,
        ),
      );

      // Сбрасываем прогресс CPC
      setCpcProgress(0);
    }
  };

  const claimCpmTask = async () => {
    const res = await claimTask('our', 2);
    console.log('Результат клейма CPM', res);
    setBalance(res.wallet.beastcoins);
    setNotification({
      type: 'Success',
      message: 'Награда за задание получена!',
      rewards:
        res.wallet.beastcoins > 0
          ? [{ amount: res.wallet.beastcoins - balance }]
          : undefined,
    });
    if (res && res.countdown_end_date) {
      // Обновляем состояние задачи с кулдауном
      setDailyTasks((prevTasks) =>
        prevTasks.map((task) =>
          task.details.type === 'CPM'
            ? {
                ...task,
                user_metadata: {
                  ...task.user_metadata,
                  status: 'CLAIMED',
                  countdown_end_date: res.countdown_end_date,
                },
              }
            : task,
        ),
      );

      // Сбрасываем прогресс CPM
      setCpmProgress(0);
    }
  };

  return (
    <div className={styles.dailyTasksContainer}>
      {isLoading ? (
        <div className={styles.loading}>
          <Loader />
        </div>
      ) : null}
      {open === 'boost' ? (
        <Modal>
          <BoostModal />
        </Modal>
      ) : null}
      <div className={styles.dailyTasksHeader}>Ежедневные</div>
      <div className={styles.dailyTasksList}>
        {dailyTasks.map((task) =>
          task.details.type === 'CPC' ? (
            <TaskItem
              key={task.id}
              task={task}
              onClick={
                cpcProgress === task.target_completion_count
                  ? claimCpcTask
                  : handleCpc
              }
              progress={cpcProgress}
              icon={<img src={cpcIcon} alt="CPC" />}
            />
          ) : (
            <TaskItem
              key={task.id}
              task={task}
              onClick={
                cpmProgress === task.target_completion_count
                  ? claimCpmTask
                  : handleCpm
              }
              progress={cpmProgress}
              icon={<img src={cpmIcon} alt="CPM" />}
            />
          ),
        )}
      </div>
    </div>
  );
};

export default DailyTasks;
